<template>
  <main-large-dialog
    header-shadow
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('admin.advancedExpressions')"
    :loading="saving"
    agree-text="dialog.agreeSave"
    @agree="onSave"
    :is-valid="isExpressionValid"
  >
    <template #body>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <data-input v-model="expression" v-bind="expressionInput" @input="unvalidate($event)" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer />
          <base-button
            class="mr-0"
            translation-path="admin.validateExpression"
            :disabled="!expression || saving"
            :loading="validating"
            @click="validate()"
          />
        </v-row>
      </v-col>
    </template>
  </main-large-dialog>
</template>
<script>
import { call } from 'vuex-pathify';

import DataInput from '@/components/DataInput';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'DataSourceAdvancedExpressionsDialog',
  components: { DataInput, MainLargeDialog },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    editingDataSource: {
      type: Object,
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    expressionInput() {
      return { dataType: { name: 'textarea' }, clearable: true, readonly: this.validating || this.saving };
    },
  },
  data: () => ({
    expression: '',
    isExpressionValid: true,
    saving: false,
    validating: false,
  }),
  methods: {
    editDataSource: call('layers/editDataSourceMetadata'),
    validateAdvancedExpression: call('admin/validateAdvancedExpression'),
    unvalidate(value) {
      if (value && value !== this.editingDataSource.user_trigger?.expression) this.isExpressionValid = false;
      else if (!value || value === this.editingDataSource.user_trigger?.expression) this.isExpressionValid = true;
    },
    async validate(expression = this.expression) {
      try {
        this.validating = true;
        await this.validateAdvancedExpression({
          dataSourceName: this.editingDataSource.name,
          payload: { expression },
        });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successAdvancedExpression'),
        });
        this.isExpressionValid = true;
      } catch {
        this.isExpressionValid = false;
      } finally {
        this.validating = false;
      }
    },
    async onSave(expression = this.expression) {
      this.saving = true;
      try {
        const payload = {
          name: this.editingDataSource.name,
          body: { user_trigger: { expression } },
        };
        await this.editDataSource(payload);
        this.computedIsVisible = false;
      } finally {
        this.saving = false;
      }
    },
  },
  watch: {
    computedIsVisible: {
      handler(nV) {
        if (nV) {
          const { user_trigger: { expression = '' } = {} } = { ...this.editingDataSource };
          this.expression = expression;
          this.isExpressionValid = true;
        }
      },
      immediate: true,
    },
  },
};
</script>
